enum ChallengeCategoryPrefix
{
    LevelPick = "pick:",
}

export default ChallengeCategoryPrefix;